import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import _isEmpty from "lodash/isEmpty"
import DOMPurify from "isomorphic-dompurify"
import useIsSsr from "@/hooks/useIsSsr"
import {
  convertStringToBoolean,
  createIdFromString,
  getRandom,
  getShortenedUrl,
  sanitizeInnerHtml,
} from "@/utils/helper"
import { getConfig } from "@/constants/config"
import { ConditionalWrapper } from "@/utils"
import DynamicImage from "@/components/core/Image/DynamicImage"
import Description from "@/components/Default/Teaser/v1/Description"
import Action from "@/components/Default/Teaser/v2/Action"
import {
  COMPONENT_TYPES,
  EMPTY_PIXEL,
  TEASER_CAPTION_CLASSES_LIST,
  TEASER_CLASSES,
} from "@/constants"
import ImagePlaceHolder from "@/components/core/Image/ImagePlaceHolder"
import Utilities from "@/components/Default/Teaser/v1/Utilities"
import { selectGenericState } from "@/store/features/genericSlice"
import { getTitleEventInfo } from "@/components/Default/Teaser/v1/analytics"

const Teaser = props => {
  const [dynamicId, setDynamicId] = useState("")
  const { pageIsInteractive } = useSelector(selectGenericState)
  const {
    data: {
      id = "",
      appliedCssClassNamesCustom = "",
      linkURLRef = false,
      linkNewTab = false,
      linkAll = false,
      linkTitle = false,
      linkImage = false,
      title = "",
      description = "",
      enableFav = false,
      enableShare = false,
      mainTitle = "",
      componentPosition = "",
      pageType = "",
      linkDescription = "",
      linkURL = "",
      caption = "",
      datalayerLinkName = "",
      componentLinkType = "",
      eventName = "",
      eventAction = "",
      actions = [],
      downLoadLink = null,
      expandText = "",
      collapseText = "",
      disableExpandCollapse = "",
      imageResource: {
        imageServerUrl: imgUrl = "",
        imageserverurl = "",
        assetID = "",
        pretitle: preTitle = "",
        urlModifiers = "",
        alt = "",
      } = {},
      utilities = [],
      utilitiesEnabled = false,
      dataLayerLinkType = "",
    } = {},
    fullData = {},
    showEmptyPlaceholder = false,
    maxHeight = "",
    containerId = "",
  } = props
  // fix for image server url missing issue - AS-11175, we will use fallback image server url here
  const imageServerUrl = imgUrl || imageserverurl;
  const [parentActionLink, setParentActionLink] = useState(linkURL)
  const [componentGroup, setComponentGroup] = useState([])
  const [appliedCssClassNamesCustoms, setAppliedCssClassNamesCustoms] =
    useState([])
  const [columnClassNames, setColumnClassNames] = useState("")
  const [general, setGeneral] = useState(null)
  const [innerCaption, setInnerCaption] = useState(false)
  const [isInsideImage, setIsInsideImage] = useState(false)
  const [activeIndex, setActive] = useState(0)
  const [isFullBleedImageHoverContent, setisFullBleedImageHoverContent] = useState(false)

  const isSsr = useIsSsr()
  const [showModal, setShowModal] = useState(false)
  const [selectedTitle, setSelectedTitle] = useState(null)
  const [selectedImage, setSelectedImage] = useState(null)
  const shouldRenderFirstActionInDescription =
    appliedCssClassNamesCustom?.includes("blog-text-hero")
  const openModal = (title, url) => {
    document.body.style.overflow = "hidden"
    setSelectedTitle(title)
    setSelectedImage(url)
    setShowModal(true)
  }
  const closeModal = () => {
    document.body.style.overflow = "unset"
    setSelectedTitle(null)
    setSelectedImage(null)
    setShowModal(false)
  }
  const isCaptionOnly = Boolean(
    title ||
      description ||
      actions?.length ||
      preTitle ||
      assetID ||
      !showEmptyPlaceholder
  )
  useEffect(() => {
    if (appliedCssClassNamesCustom?.includes("full-bleed-image-hover-content")) {
      setisFullBleedImageHoverContent(true);
    }
  }, [appliedCssClassNamesCustom])

  const containerIdName = containerId ? containerId.replace(/-/g, " ") : "zone"
  useEffect(() => {
    getConfig().then(config => {
      setGeneral(config?.general)
    })
  }, [])
  useEffect(() => {
    if (assetID) {
      const dynamicId = createIdFromString(assetID)
      setDynamicId(dynamicId)
    } else {
      const dynamicId = createIdFromString(getRandom() + "")
      setDynamicId(dynamicId)
    }
  }, [assetID])
  useEffect(() => {
    if (linkURL) {
      getShortenedUrl(linkURL).then(res => {
        setParentActionLink(res)
      })
    }
  }, [linkURL])

  useEffect(() => {
    if (!_isEmpty(fullData)) {
      Object.keys(fullData).forEach(key => {
        setAppliedCssClassNamesCustoms(appliedCssClassNamesCustom => [
          ...appliedCssClassNamesCustom,
          fullData[key]["appliedCssClassNamesCustom"],
        ])
        setComponentGroup(cmpGroup => [...cmpGroup, fullData[key][":type"]])
      })
    }
  }, [fullData])

  useEffect(() => {
    let classNameCustom = ""
    if (componentGroup.length > 0) {
      if (
        componentGroup.findIndex(a => a?.includes(COMPONENT_TYPES.TEASER)) >
          -1 &&
        appliedCssClassNamesCustoms.findIndex(a =>
          a?.includes("hero-banner-article-top")
        ) > -1 &&
        appliedCssClassNamesCustoms.findIndex(a =>
          a?.includes("hero-banner-article-bottom")
        ) === -1
      ) {
        if (!columnClassNames?.includes("hero-banner-top-only")) {
          classNameCustom += " hero-banner-top-only "
        }
        if (
          !columnClassNames?.includes("paddingbasedbreadcrum") &&
          componentGroup.findIndex(a =>
            a?.includes(COMPONENT_TYPES.BREADCRUMB)
          ) > -1
        ) {
          classNameCustom += " paddingbasedbreadcrum "
        }
        if (
          !columnClassNames?.includes("without-breadcrumb") &&
          componentGroup.findIndex(a =>
            a?.includes(COMPONENT_TYPES.BREADCRUMB)
          ) === -1
        ) {
          classNameCustom += " without-breadcrumb "
        }
      }
    }
    setColumnClassNames(className => (className += classNameCustom))
  }, [componentGroup])

  useEffect(() => {
    if (!isSsr && pageIsInteractive) {
      if (
        TEASER_CAPTION_CLASSES_LIST.some(classNames =>
          classNames
            .split(" ")
            .every(className =>
              appliedCssClassNamesCustom?.trim()?.includes(className)
            )
        )
      ) {
        setInnerCaption(true)
      }
    }
  }, [isSsr, pageIsInteractive])

  useEffect(() => {
    if (appliedCssClassNamesCustom) {
      checkUtilityPosition()
    }
  }, [appliedCssClassNamesCustom])

  const checkUtilityPosition = () => {
    let isInsideImage = false
    TEASER_CLASSES.forEach(item => {
      isInsideImage = appliedCssClassNamesCustom.includes(item)
      if (isInsideImage) {
        setIsInsideImage(isInsideImage)
        return
      }
    })
  }

  const getDataLayerLinkType = () => {
    if (mainTitle || title) {
      return `${pageType}:${mainTitle || title}`
    }
    return dataLayerLinkType
  }

  const addDataLayer = link => {
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const {
      pageInfo: { contentType, pageUrl },
      productInfo,
    } = page

    if (contentType === "pdp") {
      const eventInfo = {
        eventAction: `pdp:product details:${eventAction || mainTitle}`,
        eventName: `pdp:product details:${eventName || mainTitle}`,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: `${datalayerLinkName}`,
        internalLinkPosition: "pdp",
        internalLinkType: `pdp:teaser`,
        internalLinkZoneName: `pdp:${fullData?.teaser?.mainTitle}`,
        internalLinkURL: `${link || pageUrl || "n/a"}`,
        clickInternalLinks: `${linkNewTab ? "false" : "true"}`,
      }
      const dataLayerObj = {
        event: "cmp:click",
        page,
        eventInfo,
        productInfo,
      }
      window.adobeDataLayer.push(dataLayerObj)
    }
  }

  return (
    <div
      className={`teaser_v2 teaser ${
        appliedCssClassNamesCustom ? appliedCssClassNamesCustom : ""
      }${columnClassNames}`}
    >
      {showModal && (
        <div className="cmp-teaser landscape-modal">
          <div className="landscape-modal-content">
            <div className="s7responsiveContainer cmp-teaser__image">
              {/* Add Image */}
              <DynamicImage
                className="teaser-pop-up-image"
                imgUrl={selectedImage}
                alt={`teaser-pop-up-image`}
                area-label={`teaser-pop-up-image`}
                aria-description="image of teaser"
              />
            </div>
            {selectedTitle && (
              <div
                className="cmp-teaser__title"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(title),
                }}
              />
            )}
          </div>
          <div className="close-modal" onClick={closeModal} />
        </div>
      )}

      {isCaptionOnly ? (
        <div
          className="cmp-teaser"
          data-gbh-data-layer={`{"clickInternalLinks":"${
            linkNewTab ? "false" : "true"
          }","internalLinkPosition":"${pageType?.toLowerCase()}:${
            componentPosition || "teaser"
          }","internalLinkZoneName":"teaser","internalLinkURL":"${linkURL}","internalLinkName":"${datalayerLinkName}","eventName":"${pageType?.toLowerCase()}:${containerIdName}:${
            eventName || datalayerLinkName || "rm"
          }","internalLinkType":"${pageType}:${
            componentLinkType || mainTitle
          }","eventType":"teaser","eventAction":"${pageType?.toLowerCase()}:${containerIdName}:${
            eventAction || datalayerLinkName || "rm"
          }"}`}
        >
          <ConditionalWrapper
            condition={linkAll}
            wrapper={children => (
              <a
                href={parentActionLink}
                target={linkNewTab ? "_blank" : "_self"}
                data-gbh-clickable="true"
                rel="noreferrer"
                onClick={() => addDataLayer(parentActionLink)}
              >
                {children}
              </a>
            )}
          >
            <div className="cq-dd-image cmp-teaser__image">
              <div className="s7dm-dynamic-media cmp-image">
              {appliedCssClassNamesCustom.trim() === "moodboard-landscape-teaser" && (
                <div className="s7responsiveContainer cmp-teaser__image cmp-image__image" onClick={() =>
                  openModal(
                    title,
                    `${imageServerUrl}${assetID}`
                  )
                }>
                  <ConditionalWrapper
                    condition={linkImage}
                    wrapper={children => (
                      <a
                        href={parentActionLink}
                        target={linkNewTab ? "_blank" : "_self"}
                        data-gbh-clickable="true"
                        rel="noreferrer"
                      >
                        {children}
                      </a>
                    )}
                  >
                    {!isSsr ? (
                      assetID || showEmptyPlaceholder ? (
                        <DynamicImage
                          // style={
                          //   maxHeight && showEmptyPlaceholder && !assetID
                          //     ? { maxHeight }
                          //     : {}
                          // }
                          className="fluidimage cmp-image__image"
                          imgUrl={`${
                            assetID
                              ? `${imageServerUrl}${assetID}`
                              : EMPTY_PIXEL
                          }`}
                          alt=""
                          itemProp="contentUrl"
                          uniqueId={dynamicId}
                          urlModifiers={urlModifiers}
                        />
                      ) : (
                        <ImagePlaceHolder assetID={assetID} />
                      )
                    ) : null}
                  </ConditionalWrapper>
                </div>
              )}
              {appliedCssClassNamesCustom.trim() !== "moodboard-landscape-teaser" && (
                <div className="s7responsiveContainer cmp-teaser__image cmp-image__image">
                  <ConditionalWrapper
                    condition={linkImage}
                    wrapper={children => (
                      <a
                        href={parentActionLink}
                        target={linkNewTab ? "_blank" : "_self"}
                        data-gbh-clickable="true"
                        rel="noreferrer"
                      >
                        {children}
                      </a>
                    )}
                  >
                    {!isSsr ? (
                      assetID || showEmptyPlaceholder ? (
                        <DynamicImage
                          style={
                            maxHeight && showEmptyPlaceholder && !assetID
                              ? { maxHeight }
                              : {}
                          }
                          className="fluidimage cmp-image__image"
                          imgUrl={`${
                            assetID
                              ? `${imageServerUrl}${assetID}`
                              : EMPTY_PIXEL
                          }`}
                          alt=""
                          itemProp="contentUrl"
                          uniqueId={dynamicId}
                          urlModifiers={urlModifiers}
                        />
                      ) : (
                        <ImagePlaceHolder assetID={assetID} />
                      )
                    ) : null}
                  </ConditionalWrapper>
                </div>
              )}
              </div>
              {isInsideImage && utilitiesEnabled && utilities?.length ? (
                <Utilities
                  utilities={utilities}
                  title={title}
                  assetID={assetID}
                  imageServerUrl={imageServerUrl}
                  alt={alt}
                  pageType={pageType}
                  dataLayerLinkType={getDataLayerLinkType()}
                  mainTitle={mainTitle}
                  downLoadLink={downLoadLink}
                  containerId={containerId}
                />
              ) : null}
              {caption ? (
                <div className="cmp-img-caption">
                  {sanitizeInnerHtml(caption)}
                </div>
              ) : null}
            </div>



            {title ||
            description ||
            enableFav ||
            enableShare ||
            (actions && actions.length) ||
            preTitle ? (
              <div className="cmp-teaser__content">
                {preTitle ? (
                  <div className="cmp-teaser__pretitle">
                    {sanitizeInnerHtml(preTitle)}
                  </div>
                ) : null}
                {title ? (
                  <div className="cmp-teaser__title" id={id}>
                    <ConditionalWrapper
                      condition={linkTitle}
                      wrapper={children => (
                        <a
                          href={linkURL}
                          rel={linkURLRef ? "noreferrer" : ""}
                          target={linkNewTab ? "_blank" : "_self"}
                          data-gbh-data-layer={getTitleEventInfo(
                            linkNewTab,
                            componentPosition,
                            linkURL,
                            mainTitle,
                            pageType,
                            componentLinkType
                          )}
                          data-gbh-clickable="true"
                        >
                          {children}
                        </a>
                      )}
                    >
                      {sanitizeInnerHtml(title)}
                    </ConditionalWrapper>
                  </div>
                ) : null}
                {isFullBleedImageHoverContent ? <div className="hover-content-organized">
                  {description ? (
                  <Description
                    linkURLRef={linkURLRef}
                    general={general}
                    linkNewTab={linkNewTab}
                    description={description}
                    mainTitle={mainTitle}
                    componentPosition={componentPosition}
                    pageType={pageType}
                    linkDescription={linkDescription}
                    expandText={expandText}
                    collapseText={collapseText}
                    disableExpandCollapse={disableExpandCollapse}
                  />
                ) : null}
                {actions && actions?.length ? (
                  <div className="cmp-teaser__action-container">
                    {actions.map((action, index) => {
                      const {
                        playVideoCTA = false,
                        primaryCTA = false,
                        secondaryCTA = false,
                        url = "",
                        title = "",
                        newTab = "",
                        urlRef = "",
                      } = action

                      return (
                        <Action
                          key={`teaser-action-${index + 1}-${getRandom()}`}
                          playVideoCTA={convertStringToBoolean(playVideoCTA)}
                          primaryCTA={convertStringToBoolean(primaryCTA)}
                          secondaryCTA={convertStringToBoolean(secondaryCTA)}
                          link={url}
                          text={title}
                          newTab={convertStringToBoolean(newTab)}
                          urlRef={urlRef}
                          id={id}
                          dataLayerLinkType={dataLayerLinkType}
                          pageType={pageType}
                          linkAll={convertStringToBoolean(linkAll)}
                          mainTitle={mainTitle}
                          index={index}
                          activeIndex={activeIndex}
                          setActive={setActive}
                        />
                      )
                    })}
                  </div>
                ) : null} </div> : null}
                {description && !isFullBleedImageHoverContent ? (
                  <div className="cmp-teaser__description-action">
                    <Description
                      linkURLRef={linkURLRef}
                      general={general}
                      linkNewTab={linkNewTab}
                      description={description}
                      mainTitle={mainTitle}
                      componentPosition={componentPosition}
                      pageType={pageType}
                      linkDescription={linkDescription}
                      expandText={expandText}
                      collapseText={collapseText}
                      disableExpandCollapse={disableExpandCollapse}
                    />
                    {shouldRenderFirstActionInDescription &&
                    !isFullBleedImageHoverContent &&
                    actions &&
                    actions?.length ? (
                      <Action
                        key={`teaser-action-description-${getRandom()}`}
                        playVideoCTA={convertStringToBoolean(
                          actions[0].playVideoCTA
                        )}
                        primaryCTA={convertStringToBoolean(
                          actions[0].primaryCTA
                        )}
                        secondaryCTA={convertStringToBoolean(
                          actions[0].secondaryCTA
                        )}
                        link={actions[0].url}
                        text={actions[0].title}
                        newTab={convertStringToBoolean(actions[0].newTab)}
                        urlRef={actions[0].urlRef}
                        id={id}
                        dataLayerLinkType={dataLayerLinkType}
                        pageType={pageType}
                        linkAll={convertStringToBoolean(linkAll)}
                        mainTitle={mainTitle}
                        index={0}
                        activeIndex={activeIndex}
                        setActive={setActive}
                      />
                    ) : null}
                  </div>
                ) : null}
                {actions && !isFullBleedImageHoverContent && actions?.length ? (
                  <div className="cmp-teaser__action-container">
                    {actions.map((action, index) => {
                      if (
                        shouldRenderFirstActionInDescription &&
                        index === 0
                      ) {
                        return null
                      }
                      const {
                        playVideoCTA = false,
                        primaryCTA = false,
                        secondaryCTA = false,
                        url = "",
                        title = "",
                        newTab = "",
                        urlRef = "",
                      } = action

                      return (
                        <Action
                          key={`teaser-action-${index + 1}-${getRandom()}`}
                          playVideoCTA={convertStringToBoolean(playVideoCTA)}
                          primaryCTA={convertStringToBoolean(primaryCTA)}
                          secondaryCTA={convertStringToBoolean(secondaryCTA)}
                          link={url}
                          text={title}
                          newTab={convertStringToBoolean(newTab)}
                          urlRef={urlRef}
                          id={id}
                          dataLayerLinkType={dataLayerLinkType}
                          pageType={pageType}
                          linkAll={convertStringToBoolean(linkAll)}
                          mainTitle={mainTitle}
                          index={index}
                          activeIndex={activeIndex}
                          setActive={setActive}
                        />
                      )
                    })}
                  </div>
                ) : null}
                {!isInsideImage && utilitiesEnabled && utilities?.length ? (
                  <Utilities
                    utilities={utilities}
                    title={title}
                    assetID={assetID}
                    imageServerUrl={imageServerUrl}
                    alt={alt}
                    pageType={pageType}
                    dataLayerLinkType={getDataLayerLinkType()}
                    mainTitle={mainTitle}
                    downLoadLink={downLoadLink}
                    containerId={containerId}
                  />
                ) : null}
              </div>
            ) : null}
          </ConditionalWrapper>
        </div>
      ) : null}
      {innerCaption ? (
        <div className="cmp-img-caption">{sanitizeInnerHtml(caption)}</div>
      ) : null}
    </div>
  )
}

export default Teaser
